import React from 'react'
import {BsLinkedin} from 'react-icons/bs'
import {FaGithub} from 'react-icons/fa'
import './header.css'



const HeaderSocials = () => {
  return (
    <div className='header__socials'>
        <a href='https://www.linkedin.com/in/mrsharifi/' target='_blank'><BsLinkedin /></a>
        {/* <a href='https://github.com/mrsharifii' target='_blank'><FaGithub /></a> */}
    </div>
  )
}

export default HeaderSocials
